export class Weighting {
  id: number; 
  description: string;
  unit: string;
}
